// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3BP6j","title":"ClientReferral_title__MwyvO","itemText":"ClientReferral_itemText__1CnlA"};